module.exports = __webpack_public_path__ + "static/media/availability_settings.71a2261e.png";